// extracted by mini-css-extract-plugin
export var avatarContainer = "_40-1";
export var largeAvatarContainer = "_40-2";
export var smallAvatarContainer = "_40-0";